/**
 * Carlino — hall storleksraden pa produktkortet i takt med vald fargswatch.
 *
 * Kortet byter bild klientsidigt nar kunden klickar en swatch (se ProductCard i theme.js),
 * men storleksraden renderas en gang pa servern och ligger kvar. Foljden ar ett kort som
 * visar den beiga skon bredvid navys lagersaldo, vilket ar samma fel som rapporterades fran
 * borjan, bara ett klick senare.
 *
 * product-card-sizes.liquid skriver hela farg-till-storlek-tabellen i data-card-size-map.
 * Har lases den och raden skrivs om vid varje swatch-byte. Ingen natverkstrafik behovs.
 *
 * Fargens namn hamtas ur swatchens dolda etikett, samma text som skarmlasaren far. Radions
 * value ar ett option-value-id och duger inte som nyckel.
 */
(function () {
  'use strict';

  var UNAVAILABLE_CLASS = 'product-card__size--unavailable';

  function parseMap(row) {
    var raw = row.getAttribute('data-card-size-map');

    if (!raw) {
      return null;
    }

    // Attributet bar objektets innehall utan ytterklamrar. Shopifys Liquid-parser vagrar
    // en klammer som strangliteral i en output-tagg, sa de laggs tillbaka har.
    try {
      return JSON.parse('{' + raw + '}');
    } catch (error) {
      return null;
    }
  }

  function colorNameFor(input) {
    var label = input.nextElementSibling;

    if (!label) {
      return null;
    }

    var srOnly = label.querySelector('.sr-only');
    var text = srOnly ? srOnly.textContent : label.textContent;

    return text ? text.trim() : null;
  }

  function applyColor(row, colorName) {
    var map = parseMap(row);

    if (!map || !colorName) {
      return;
    }

    var available = map[colorName];

    // En farg som saknas i tabellen betyder att servern och den har filen ar ur synk.
    // Da lamnas raden orord hellre an att allt stryks over.
    if (!available) {
      return;
    }

    Array.prototype.forEach.call(row.querySelectorAll('[data-size]'), function (item) {
      var size = item.getAttribute('data-size');

      item.classList.toggle(UNAVAILABLE_CLASS, available.indexOf(size) === -1);
    });
  }

  function rowWithin(card) {
    return card.querySelector('[data-card-size-map]');
  }

  function onChange(event) {
    var input = event.target;

    if (!input || input.type !== 'radio' || !input.name || input.name.indexOf('swatch-') !== 0) {
      return;
    }

    var card = input.closest('product-card, .product-card');

    if (!card) {
      return;
    }

    var row = rowWithin(card);

    if (!row) {
      return;
    }

    applyColor(row, colorNameFor(input));
  }

  document.addEventListener('change', onChange);
})();